import { api, type RequestOptions } from "./client";

export interface ConversationDto {
  id:                  string;
  customer_id:         string | null;
  channel:             string;
  channel_thread_id:   string;
  status:              string;
  agent_mode:          string;
  last_message_at:     string | null;
  created_at:          string;
}

export interface MessageDto {
  id:             string;
  role:           "customer" | "agent" | "operator" | "system" | "supplier";
  sender_label:   string | null;
  text:           string | null;
  attachments:    Array<Record<string, unknown>>;
  agent_run_id:   string | null;
  created_at:     string;
}

export interface InboundMessageRequest {
  channel:           string;
  channel_thread_id: string;
  text?:             string;
  sender_label?:     string;
  telegram_user_id?: number;
  phone?:            string;
  email?:            string;
}

export interface InboundAcceptedDto {
  correlation_id: string;
  event_id:       string;
}

export const conversationsApi = {
  get(conversationId: string, opts?: RequestOptions): Promise<ConversationDto> {
    return api.get<ConversationDto>(`/conversations/${conversationId}`, opts);
  },

  listMessages(
    conversationId: string, limit = 100, opts?: RequestOptions,
  ): Promise<MessageDto[]> {
    return api.get<MessageDto[]>(
      `/conversations/${conversationId}/messages?limit=${limit}`, opts,
    );
  },

  postInbound(
    body: InboundMessageRequest, opts?: RequestOptions,
  ): Promise<InboundAcceptedDto> {
    return api.post<InboundAcceptedDto>("/conversations/inbound", body, opts);
  },

  // ---- Sprint B: Human takeover --------------------------------------------

  takeover(
    conversationId: string, note?: string, opts?: RequestOptions,
  ): Promise<ConversationDto> {
    return api.post<ConversationDto>(
      `/conversations/${conversationId}/takeover`, { note }, opts,
    );
  },

  release(
    conversationId: string, opts?: RequestOptions,
  ): Promise<ConversationDto> {
    return api.post<ConversationDto>(
      `/conversations/${conversationId}/release`, {}, opts,
    );
  },

  reply(
    conversationId: string, text: string, opts?: RequestOptions,
  ): Promise<{ message_id: string }> {
    return api.post<{ message_id: string }>(
      `/conversations/${conversationId}/reply`, { text }, opts,
    );
  },
};
